module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col flex-1 min-h-0 relative bg-white rounded-b-lg pb-3"
  }, [(_vm.getCurrentDiscussion && _vm.getCurrentDiscussion.audio_discussion_is_enabled === true) ? _c('div', {
    staticClass: "flex flex-col flex-1 min-h-0"
  }, [(_vm.discussion_is_live) ? _c('div', {
    staticClass: "flex flex-col flex-1 min-h-0"
  }, [(!_vm.has_joined_discussion) ? _c('div', {
    staticClass: "flex flex-1 flex-col justify-center -mt-20 items-center min-h-0 space-y-8 overflow-y-auto px-3 py-3"
  }, [_c('JoinDiscussion', {
    attrs: {
      "isJoinedAudioDiscussion": _vm.joinedAudioDiscussion
    }
  })], 1) : _c('div', {
    staticClass: "flex flex-col flex-1 min-h-0 px-3 py-3"
  }, [(_vm.discussion_is_live) ? _c('div', {
    staticClass: "flex w-full relative items-start flex-1 min-h-0 space-x-1.5"
  }, [_c('div', {
    class: [{
      'w-3/12 2xl:w-2/12 h-full flex-col space-y-1.5 overflow-y-auto': _vm.isDiscussionSharingScreen === true && _vm.selectedLiveView === 'one_columns',
      'w-full h-full': _vm.isDiscussionSharingScreen === true && _vm.selectedLiveView === 'only_screen',
      'h-full grid gap-1.5 w-full sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 overflow-y-auto': _vm.isDiscussionSharingScreen === false && _vm.isNotepadOpen === false && !_vm.tap_in_screen,
      'h-full grid gap-1.5 w-full sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 overflow-y-auto': _vm.isDiscussionSharingScreen === false && _vm.isNotepadOpen === true && !_vm.tap_in_screen,
      'w-full h-full px-4 py-4': _vm.tap_in_screen,
    }]
  }, [((_vm.audio_is_enabled || _vm.tap_in_screen) && _vm.course_author) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.tap_in_screen && _vm.tap_in_screen === _vm.course_author.id) || !_vm.tap_in_screen),
      expression: "(tap_in_screen && tap_in_screen === course_author.id) || !tap_in_screen"
    }],
    staticClass: "relative"
  }, [(!_vm.tap_in_screen) ? _c('div', {
    staticClass: "absolute -mt-5 text-white rounded-t w-full flex justify-center bg-gray-400"
  }, [_vm._v("\n                Author\n              ")]) : _vm._e(), _vm._v(" "), _c('LDDiscussionTeacherCircle', {
    attrs: {
      "id": ("circle-list-" + (_vm.course_author.id)),
      "joinedAudioDiscussion": _vm.joinedAudioDiscussion,
      "remoteUsers": _vm.remoteUsers,
      "rtc": _vm.rtc,
      "teacher_tap_in": _vm.tap_in_screen,
      "course_author": _vm.course_author
    }
  }), _vm._v(" "), (_vm.tap_in_screen) ? _c('div', [_vm._v("Teacher Tap In")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), ((_vm.audio_is_enabled || _vm.tap_in_screen) && _vm.isTeacherOnline(_vm.getCurrentDiscussion.author_id)) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.tap_in_screen && _vm.tap_in_screen === _vm.getCurrentDiscussion.author_id) || (!_vm.tap_in_screen && _vm.selectedLiveView !== 'only_screen')),
      expression: "(tap_in_screen && tap_in_screen === getCurrentDiscussion.author_id) || (!tap_in_screen && selectedLiveView !== 'only_screen')"
    }],
    staticClass: "relative w-full overflow-y-hidden h-full"
  }, [_c('LDDiscussionTeacherCircle', {
    attrs: {
      "id": ("circle-list-" + (_vm.getCurrentDiscussion.author_id)),
      "joinedAudioDiscussion": _vm.joinedAudioDiscussion,
      "remoteUsers": _vm.remoteUsers,
      "rtc": _vm.rtc,
      "teacher_tap_in": _vm.tap_in_screen
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.co_teachers), function(coteacher, index) {
    return ((_vm.audio_is_enabled || _vm.tap_in_screen) && _vm.isCoTeacherOnline(coteacher.id)) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((_vm.tap_in_screen && _vm.tap_in_screen === coteacher.id) || !_vm.tap_in_screen || _vm.selectedLiveView !== 'only_screen'),
        expression: "(tap_in_screen && tap_in_screen === coteacher.id) || !tap_in_screen || selectedLiveView !== 'only_screen'"
      }],
      key: coteacher.id + index,
      staticClass: "relative"
    }, [(!_vm.tap_in_screen) ? _c('div', {
      staticClass: "text-white text-xs py-0.5 font-poppins rounded-t w-full flex justify-center bg-gray-400"
    }, [_vm._v("\n                Co-Teacher\n              ")]) : _vm._e(), _vm._v(" "), _c('LDDiscussionCoTeacherCircle', {
      attrs: {
        "id": ("circle-list-" + (coteacher.id)),
        "coteacher": coteacher,
        "joinedAudioDiscussion": _vm.joinedAudioDiscussion,
        "remoteUsers": _vm.remoteUsers,
        "rtc": _vm.rtc,
        "co_teacher_tap_in": _vm.tap_in_screen
      }
    }), _vm._v(" "), (_vm.tap_in_screen) ? _c('div', {
      staticClass: "font-poppins bg-gray-100 rounded-full px-3.5 border border-solid border-gray-200 py-2 mt-5"
    }, [_vm._v("\n                Co-Teacher Tap In\n              ")]) : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), (_vm.speakerInTurnCircle === false) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedLiveView !== 'only_screen'),
      expression: "selectedLiveView !== 'only_screen'"
    }],
    staticClass: "relative",
    class: _vm.tap_in_screen ? 'hidden' : ''
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.turns_in_circle), function(turn, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selectedLiveView !== 'only_screen'),
        expression: "selectedLiveView !== 'only_screen'"
      }],
      key: turn.id,
      class: _vm.tap_in_screen ? 'hidden' : ''
    }, [_c('LDDiscussionCircle', {
      attrs: {
        "id": ("circle-list-" + (turn.participation.user.id)),
        "currentTurn": turn,
        "currentSpeaker": _vm.current_speaker,
        "queueIndex": index,
        "participationID": turn.participation.id,
        "joinedAudioDiscussion": _vm.joinedAudioDiscussion,
        "remoteUsers": _vm.remoteUsers,
        "loading_queue": _vm.loading_queue
      },
      on: {
        "openSendNudge": function($event) {
          return _vm.$emit('openSendNudge', true, turn.participation)
        }
      }
    })], 1)
  })], 2), _vm._v(" "), (_vm.isDiscussionSharingScreen === true) ? _c('div', {
    class: [{
      'w-8/12 relative flex flex-col min-h-0': _vm.selectedLiveView === 'columns',
      'w-9/12 2xl:w-10/12 relative flex flex-col min-h-0': _vm.selectedLiveView === 'one_columns',
      'absolute inset-0 w-full': _vm.selectedLiveView === 'only_screen',
    }]
  }, [_c('div', {
    class: ['relative w-full overflow-hidden', _vm.selectedLiveView === 'only_screen' ? 'h-full' : 'aspect-w-16 aspect-h-9']
  }, [_c('div', {
    staticClass: "absolute inset-0 w-full flex flex-col justify-center items-center bg-gray-800 border border-solid border-gray-200",
    attrs: {
      "id": 'screen-share-container'
    }
  }, [_c('div', {
    staticClass: "flex absolute bottom-2 left-2 z-50 items-center space-x-2"
  }, [(_vm.getCurrentDiscussion.is_sample === false) ? _c('div', [(_vm.show_bad_network_quality) ? _c('Tooltip', {
    attrs: {
      "text": "The connection is weak",
      "styleTooltip": "-top-1 right-full mr-2.5",
      "padding": "px-2.5 py-1"
    }
  }, [_c('i', {
    staticClass: "fas fa-wifi text-red-500 cursor-pointer mb-1.5"
  })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('pl-menu', {
    attrs: {
      "menuSize": 3,
      "direction": "right"
    }
  }, [(_vm.isDiscussionSharingScreen) ? _c('button', {
    staticClass: "bg-gray-50 border border-solid -mt-1.5 border-gray-300 h-8 rounded-full flex items-center text-xs space-x-2 text-gray-700 px-2.5 py-1.5",
    attrs: {
      "slot": "menu_trigger"
    },
    slot: "menu_trigger"
  }, [_c('i', {
    staticClass: "fa-solid fa-table-columns"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa-solid fa-chevron-down"
  })]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "text-sm text-gray-700",
    attrs: {
      "menu-content": ""
    }
  }, [_c('li', {
    staticClass: "bg-white border-b border-solid border-gray-200 cursor-pointer hover:bg-gray-100 py-1.5 px-2",
    on: {
      "click": function($event) {
        return _vm.handleChangeView('one_columns')
      }
    }
  }, [_c('span', [_vm._v("Normal")])]), _vm._v(" "), _c('li', {
    staticClass: "bg-white hover:bg-gray-100 cursor-pointer py-1.5 px-2",
    on: {
      "click": function($event) {
        return _vm.handleChangeView('only_screen')
      }
    }
  }, [_c('span', [_vm._v("Only Screen")])])])])], 1)])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.discussion_is_live && _vm.audio_is_enabled) ? _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.has_joined_discussion && _vm.selectedLiveView !== 'only_screen'),
      expression: "has_joined_discussion && selectedLiveView !== 'only_screen'"
    }],
    staticClass: "flex pt-2 border-t border-gray-200 w-full mt-auto mb-[calc(var(--toolbar-h)+0.75rem)]"
  }, [(_vm.show_arrows) ? _c('button', {
    staticClass: "opacity-50 hover:opacity-100",
    on: {
      "click": function($event) {
        return _vm.slide('left')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-left mr-2.5 text-xl"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "slides-container",
    attrs: {
      "id": "slides-container"
    }
  }, [(!_vm.hasTeacherPermissionsInCourse) ? _c('div', {
    staticClass: "relative mr-1",
    on: {
      "mouseover": function($event) {
        _vm.isToSeeSettings = true
      },
      "mouseleave": function($event) {
        _vm.isToSeeSettings = false
      }
    }
  }, [_c('div', {
    staticClass: "bg-gray-50 border border-solid border-gray-200 rounded-lg relative",
    staticStyle: {
      "width": "120px",
      "height": "75px"
    }
  }, [_c('div', {
    staticClass: "w-full flex flex-col h-full relative"
  }, [_c('div', {
    staticClass: "flex-grow relative"
  }, [_c('div', {
    staticClass: "flex justify-center flex-grow h-full"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.camera),
      expression: "!camera"
    }],
    staticClass: "flex flex-col justify-center items-center h-full"
  }, [_c('img', {
    staticClass: "rounded-full w-6 h-6",
    attrs: {
      "src": _vm.getProfile.avatar_url,
      "alt": "Avatar"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.camera),
      expression: "camera"
    }],
    staticClass: "h-full"
  }, [_c('video', {
    staticClass: "local-camera absolute object-cover inset-0 w-full h-full",
    class: _vm.present_in_circle ? 'opacity-50' : '',
    attrs: {
      "autoplay": ""
    }
  })])]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), (_vm.camera && _vm.isToSeeSettings) ? _c('button', {
    staticClass: "absolute top-6 left-12 z-10",
    on: {
      "click": _vm.openDeviceSettings
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-gear text-white text-base"
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.turns_video_audio_on.length) ? _c('div', {
    staticClass: "flex space-x-1",
    attrs: {
      "id": "slide-cards"
    }
  }, _vm._l((_vm.turns_video_audio_on), function(turn) {
    return _c('div', {
      key: turn.id,
      staticClass: "relative bg-gray-100",
      class: _vm.hasTeacherPermissionsInCourse ? 'cursor-pointer' : '',
      staticStyle: {
        "width": "120px",
        "height": "75px"
      },
      attrs: {
        "id": ("circle-list-" + (turn.participation.user.id))
      },
      on: {
        "click": function($event) {
          return _vm.openStudentAssessment(turn)
        }
      }
    }, [_c('div', {
      staticClass: "w-full h-full flex items-center justify-center"
    }, [_c('img', {
      staticClass: "rounded-full w-10 h-10",
      attrs: {
        "src": turn.participation.user.avatar_url,
        "alt": "Avatar"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "absolute bottom-2 right-2 px-2 py-0.5 bg-black rounded-full text-white text-xs opacity-60 z-10"
    }, [_vm._v("\n                  " + _vm._s(turn.participation.user.name.split(' ')[0]) + "\n                ")])])
  }), 0) : _c('div', {
    staticClass: "flex items-center space-x-1 w-full"
  }, _vm._l((3), function(i) {
    return _c('div', {
      key: i,
      staticClass: "relative bg-gray-100 rounded",
      staticStyle: {
        "height": "75px",
        "width": "120px"
      }
    }, [_c('div', {
      staticClass: "absolute bottom-2.5 left-2.5 w-10 rounded-full h-4 bg-gray-200"
    })])
  }), 0)]), _vm._v(" "), (_vm.show_arrows) ? _c('button', {
    staticClass: "opacity-50 hover:opacity-100",
    on: {
      "click": function($event) {
        return _vm.slide('right')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right ml-2.5 text-xl"
  })]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "bar-fade-slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.discussion_is_live && _vm.isIdle)),
      expression: "!(discussion_is_live && isIdle)"
    }],
    staticClass: "w-full sticky bottom-3 px-3 z-40"
  }, [(_vm.hasTeacherPermissionsInCourse) ? _c('LDDiscussionTeacherBar', {
    attrs: {
      "statusCamera": _vm.camera,
      "statusMicro": _vm.muted,
      "joinedAudioDiscussion": _vm.joinedAudioDiscussion
    },
    on: {
      "show_polls": function($event) {
        _vm.show_polls = true
      },
      "show_questions": function($event) {
        _vm.show_discussion_questions_modal = true
      },
      "handleChangeVideoStatus": function($event) {
        return _vm.handleToggleVideo()
      },
      "handleChangeMicroStatus": function($event) {
        return _vm.handleToggleMicro()
      },
      "toggleFullscreen": function($event) {
        return _vm.$emit('toggleFullscreen')
      }
    }
  }) : _c('LDDiscussionStudentBar', {
    attrs: {
      "statusCamera": _vm.camera,
      "statusMicro": _vm.muted,
      "joinedAudioDiscussion": _vm.joinedAudioDiscussion
    },
    on: {
      "show_polls": function($event) {
        _vm.show_polls = true
      },
      "handleChangeVideoStatus": function($event) {
        return _vm.handleToggleVideo()
      },
      "handleChangeMicroStatus": function($event) {
        return _vm.handleToggleMicro()
      },
      "toggleFullscreen": function($event) {
        return _vm.$emit('toggleFullscreen')
      }
    }
  })], 1)])], 1) : _c('div', {
    staticClass: "flex flex-col flex-1 min-h-0"
  }, [(!_vm.discussion_is_live) ? _c('div', {
    staticClass: "flex flex-col flex-1 min-h-0 h-full overflow-y-auto justify-center items-center"
  }, [(_vm.discussion_is_ended && _vm.getCurrentDiscussion.participations.length > 0) ? _c('div', {
    staticClass: "h-full flex flex-col items-center justify-center p-6 font-manrope"
  }, [_c('VerbalDiscussionEnded')], 1) : _c('div', {
    staticClass: "h-full w-full"
  }, [_c('VerbalDiscussionOffline')], 1)]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "bar-fade-slide"
    }
  }, [(_vm.getCurrentDiscussion.participations.length > 0) ? _c('div', {
    staticClass: "w-full sticky bottom-3 px-3 z-40"
  }, [(_vm.hasTeacherPermissionsInCourse) ? _c('LDDiscussionTeacherBar', {
    attrs: {
      "statusCamera": _vm.camera,
      "statusMicro": _vm.muted,
      "joinedAudioDiscussion": _vm.joinedAudioDiscussion
    },
    on: {
      "show_polls": function($event) {
        _vm.show_polls = true
      },
      "show_questions": function($event) {
        _vm.show_discussion_questions_modal = true
      },
      "handleChangeVideoStatus": function($event) {
        return _vm.handleToggleVideo()
      },
      "handleChangeMicroStatus": function($event) {
        return _vm.handleToggleMicro()
      },
      "toggleFullscreen": function($event) {
        return _vm.$emit('toggleFullscreen')
      }
    }
  }) : _c('LDDiscussionStudentBar', {
    attrs: {
      "statusCamera": _vm.camera,
      "statusMicro": _vm.muted,
      "joinedAudioDiscussion": _vm.joinedAudioDiscussion
    },
    on: {
      "show_polls": function($event) {
        _vm.show_polls = true
      },
      "handleChangeVideoStatus": function($event) {
        return _vm.handleToggleVideo()
      },
      "handleChangeMicroStatus": function($event) {
        return _vm.handleToggleMicro()
      },
      "toggleFullscreen": function($event) {
        return _vm.$emit('toggleFullscreen')
      }
    }
  })], 1) : _vm._e()])], 1)]) : _c('div', {
    staticClass: "flex flex-col flex-1 min-h-0"
  }, [(_vm.discussion_is_live) ? _c('div', {
    staticClass: "flex flex-col flex-1 min-h-0"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.tap_in_screen),
      expression: "!tap_in_screen"
    }],
    staticClass: "flex-1 min-h-0 overflow-y-auto px-3 py-3"
  }, [_c('div', {
    class: [{
      'h-full grid gap-1.5 w-full sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 overflow-y-auto': _vm.isDiscussionSharingScreen === false && _vm.isNotepadOpen === false && !_vm.tap_in_screen,
      'h-full grid gap-1.5 w-full sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 overflow-y-auto': _vm.isDiscussionSharingScreen === false && _vm.isNotepadOpen === true && !_vm.tap_in_screen,
    }]
  }, [(_vm.speakerInTurnCircle === false) ? _c('div', {
    staticClass: "relative"
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.turns_in_circle), function(turn, index) {
    return _c('div', {
      key: turn.id,
      class: _vm.tap_in_screen ? 'hidden' : ''
    }, [_c('LDDiscussionCircle', {
      attrs: {
        "id": ("circle-list-" + (turn.participation.user.id)),
        "currentTurn": turn,
        "currentSpeaker": _vm.current_speaker,
        "queueIndex": index,
        "participationID": turn.participation.id,
        "joinedAudioDiscussion": _vm.joinedAudioDiscussion,
        "remoteUsers": _vm.remoteUsers,
        "loading_queue": _vm.loading_queue
      },
      on: {
        "openSendNudge": function($event) {
          return _vm.$emit('openSendNudge', true, turn.participation)
        }
      }
    })], 1)
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tap_in_screen),
      expression: "tap_in_screen"
    }],
    staticClass: "flex-1 min-h-0 overflow-y-auto px-3 py-3 flex flex-col justify-center items-center"
  }, [_c('LDDiscussionTeacherCircle', {
    attrs: {
      "id": ("circle-list-" + (_vm.getCurrentDiscussion.author_id)),
      "joinedAudioDiscussion": _vm.joinedAudioDiscussion,
      "remoteUsers": _vm.remoteUsers,
      "rtc": _vm.rtc,
      "teacher_tap_in": _vm.tap_in_screen
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "bar-fade-slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isIdle),
      expression: "!isIdle"
    }],
    staticClass: "w-full sticky bottom-3 px-3 z-40"
  }, [(_vm.hasTeacherPermissionsInCourse) ? _c('LDDiscussionTeacherBar', {
    attrs: {
      "statusCamera": _vm.camera,
      "statusMicro": _vm.muted,
      "joinedAudioDiscussion": _vm.joinedAudioDiscussion
    },
    on: {
      "show_polls": function($event) {
        _vm.show_polls = true
      },
      "show_questions": function($event) {
        _vm.show_discussion_questions_modal = true
      },
      "handleChangeVideoStatus": function($event) {
        return _vm.handleToggleVideo()
      },
      "handleChangeMicroStatus": function($event) {
        return _vm.handleToggleMicro()
      },
      "toggleFullscreen": function($event) {
        return _vm.$emit('toggleFullscreen')
      }
    }
  }) : _c('LDDiscussionStudentBar', {
    attrs: {
      "statusCamera": _vm.camera,
      "statusMicro": _vm.muted,
      "joinedAudioDiscussion": _vm.joinedAudioDiscussion
    },
    on: {
      "show_polls": function($event) {
        _vm.show_polls = true
      },
      "handleChangeVideoStatus": function($event) {
        return _vm.handleToggleVideo()
      },
      "handleChangeMicroStatus": function($event) {
        return _vm.handleToggleMicro()
      },
      "toggleFullscreen": function($event) {
        return _vm.$emit('toggleFullscreen')
      }
    }
  })], 1)])], 1) : _c('div', {
    staticClass: "flex flex-col flex-1 min-h-0"
  }, [(!_vm.discussion_is_live) ? _c('div', {
    staticClass: "flex flex-col flex-1 min-h-0 h-full overflow-y-auto justify-center items-center"
  }, [(_vm.discussion_is_ended && _vm.getCurrentDiscussion.participations.length > 0) ? _c('div', {
    staticClass: "h-full flex flex-col items-center justify-center p-6 font-manrope"
  }, [_c('VerbalDiscussionEnded')], 1) : _c('div', {
    staticClass: "h-full w-full"
  }, [_c('VerbalDiscussionOffline')], 1)]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "bar-fade-slide"
    }
  }, [(_vm.getCurrentDiscussion.participations.length > 0) ? _c('div', {
    staticClass: "w-full sticky bottom-3 px-3 z-40"
  }, [(_vm.hasTeacherPermissionsInCourse) ? _c('LDDiscussionTeacherBar', {
    attrs: {
      "statusCamera": _vm.camera,
      "statusMicro": _vm.muted,
      "joinedAudioDiscussion": _vm.joinedAudioDiscussion
    },
    on: {
      "show_polls": function($event) {
        _vm.show_polls = true
      },
      "show_questions": function($event) {
        _vm.show_discussion_questions_modal = true
      },
      "handleChangeVideoStatus": function($event) {
        return _vm.handleToggleVideo()
      },
      "handleChangeMicroStatus": function($event) {
        return _vm.handleToggleMicro()
      },
      "toggleFullscreen": function($event) {
        return _vm.$emit('toggleFullscreen')
      }
    }
  }) : _c('LDDiscussionStudentBar', {
    attrs: {
      "statusCamera": _vm.camera,
      "statusMicro": _vm.muted,
      "joinedAudioDiscussion": _vm.joinedAudioDiscussion
    },
    on: {
      "show_polls": function($event) {
        _vm.show_polls = true
      },
      "handleChangeVideoStatus": function($event) {
        return _vm.handleToggleVideo()
      },
      "handleChangeMicroStatus": function($event) {
        return _vm.handleToggleMicro()
      },
      "toggleFullscreen": function($event) {
        return _vm.$emit('toggleFullscreen')
      }
    }
  })], 1) : _vm._e()])], 1)]), _vm._v(" "), (_vm.second_screen_modal) ? _c('pl-dialog', {
    attrs: {
      "title": 'Second Screen',
      "size": 'relative',
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        _vm.second_screen_modal = false
      }
    }
  }, [_c('div', {
    staticClass: "flex-grow p-7"
  }, [_c('div', {
    staticClass: "h-full flex flex-col"
  }, [_c('p', [_vm._v("\n          Share this onto a second screen for your class to view in addition\n          to what they see on their own devices.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          This screen will not show you taking notes, nudging or assessing\n          students as that will occur in the existing Parlay tab on your\n          device.\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center px-7 pb-7"
  }, [_c('button', {
    staticClass: "px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold",
    on: {
      "click": function($event) {
        _vm.second_screen_modal = false
      }
    }
  }, [_vm._v("\n        OK, got it!\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.show_saved_feedback_modal) ? _c('NewFeedbackModal', {
    attrs: {
      "typeRoundtable": "live",
      "feedbackID": _vm.feedback_id,
      "feedbackContent": _vm.feedback_content,
      "editingFeedback": _vm.set_edit_saved_feedback
    },
    on: {
      "close": _vm.closeNewFeedbackModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_import_feedback_modal) ? _c('ImportFeedbackModal', {
    attrs: {
      "typeRoundtable": "live"
    },
    on: {
      "close": _vm.closeImportFeedbackTemplatesModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_confirm_delete_feedback) ? _c('dialog-delete-confirm', {
    attrs: {
      "header": 'Delete this saved feedback template',
      "subHeader": 'It will be permanently removed from this course.'
    },
    on: {
      "close": _vm.cancelDeleteSavedFeedback,
      "actionConfirmed": _vm.confirmDeleteSavedFeedback
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative bg-gray-100 rounded-b-md h-56"
  }, [_c('div', {
    staticClass: "bg-gray-400 w-full text-white rounded-t text-xs font-poppins py-0.5 flex justify-center"
  }, [_vm._v("\n                  Speaker\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "absolute",
    staticStyle: {
      "top": "calc(50% - 40px)",
      "left": "calc(50% - 32px)"
    }
  }, [_c('div', {
    staticClass: "rounded-full bg-gray-200",
    staticStyle: {
      "width": "70px",
      "height": "70px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "absolute left-3 bottom-2.5 w-20 h-7 rounded-full bg-gray-200"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-10 select-none absolute bg-pinky text-white px-2 rounded-full py-0.5 bottom-2 right-2 text-xs opacity-80"
  }, [_c('span', [_vm._v("Me")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative bg-gray-100 rounded-b-md h-56"
  }, [_c('div', {
    staticClass: "bg-gray-400 w-full text-white rounded-t text-xs font-poppins py-0.5 flex justify-center"
  }, [_vm._v("\n                Speaker\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "absolute",
    staticStyle: {
      "top": "calc(50% - 40px)",
      "left": "calc(50% - 32px)"
    }
  }, [_c('div', {
    staticClass: "rounded-full bg-gray-200",
    staticStyle: {
      "width": "70px",
      "height": "70px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "absolute left-3 bottom-2.5 w-20 h-7 rounded-full bg-gray-200"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-1698a049!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/tabs/LDDiscussionTab.vue
// module id = 1793
// module chunks = 61